var map = {
	"./CooksLogo": 9,
	"./CooksLogo.svg": 9,
	"./Icon-feather-message-circle": 10,
	"./Icon-feather-message-circle.svg": 10,
	"./awesome-long-arrow-alt-left": 11,
	"./awesome-long-arrow-alt-left.svg": 11,
	"./awesome-long-arrow-alt-right": 12,
	"./awesome-long-arrow-alt-right.svg": 12,
	"./burger": 13,
	"./burger.svg": 13,
	"./close": 14,
	"./close.svg": 14,
	"./cooksGreenLogo": 15,
	"./cooksGreenLogo.svg": 15,
	"./enlarge": 16,
	"./enlarge.svg": 16,
	"./favicon": 17,
	"./favicon.png": 17,
	"./icon-email": 18,
	"./icon-email.svg": 18,
	"./icon-facebook": 19,
	"./icon-facebook.svg": 19,
	"./icon-phone": 20,
	"./icon-phone.svg": 20,
	"./supplied/img-welder-fade": 21,
	"./supplied/img-welder-fade.jpg": 21,
	"./supplied/metalStructure": 22,
	"./supplied/metalStructure.jpg": 22,
	"./supplied/mowerSlider": 23,
	"./supplied/mowerSlider.jpg": 23,
	"./supplied/projectSlider/117392896_1983665295097203_3081992922489184737_o": 24,
	"./supplied/projectSlider/117392896_1983665295097203_3081992922489184737_o.jpg": 24,
	"./supplied/projectSlider/118916576_2014553958675003_1007267624543328943_o": 25,
	"./supplied/projectSlider/118916576_2014553958675003_1007267624543328943_o.jpg": 25,
	"./supplied/projectSlider/132512719_2119037438226654_3093555080341113767_o": 26,
	"./supplied/projectSlider/132512719_2119037438226654_3093555080341113767_o.jpg": 26,
	"./supplied/projectSlider/132661689_2119037394893325_1770303592596982574_o": 27,
	"./supplied/projectSlider/132661689_2119037394893325_1770303592596982574_o.jpg": 27,
	"./supplied/projectSlider/89782256_1831112010352533_8440356798229118976_n": 28,
	"./supplied/projectSlider/89782256_1831112010352533_8440356798229118976_n.jpg": 28,
	"./supplied/projectSlider/89846248_1842997595830641_6746119472723001344_n": 29,
	"./supplied/projectSlider/89846248_1842997595830641_6746119472723001344_n.jpg": 29,
	"./supplied/spiralStaircase": 30,
	"./supplied/spiralStaircase.jpg": 30
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;